import { environment } from "@environment";
export const VERSION_DATA = window.analyticsData || {};

export const SEAL_VALIDATION_URL = `https://storage.googleapis.com/${environment.assetsBucket}/${
  VERSION_DATA.orgId
}/${VERSION_DATA.storyId}/${VERSION_DATA.versionId}/seal.json?${Date.now()}`;

export const KEYS = ["orgId", "storyId", "versionId", "versionCreatorId"];
export const PAGE_URL = window.location.href.split("?")[0];
export const PAGE_TITLE = document.title;

export const HOST = window.location.host;
export const HREF = window.location.href;
export const INVALID_HOSTS = [
  "localhost",
  "editor-staging.storydoc.com",
  "editor.storydoc.com",
];

export const IS_PRIMARY_VERSION =
  VERSION_DATA.versionId && VERSION_DATA.versionId === window.primaryVersionId;

export const SUBMISSION_DISABLED =
  INVALID_HOSTS.includes(HOST) ||
  /\/version-preview|preview=true|\/preview/.test(HREF) ||
  !Object.keys(VERSION_DATA).length ||
  VERSION_DATA.versionId?.includes("{{") ||
  IS_PRIMARY_VERSION;
